export const exportDownloadSingle = async (filename, sheetName, rows) => {
  // Dynamically load xlsx ONLY when needed
  const XLSX = await import(/* webpackChunkName: "xlsx" */ "xlsx");

  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  console.log("NEW");
  XLSX.writeFile(workbook, filename);
};

export const createWorkbook = async () => {
  const XLSX = await import(/* webpackChunkName: "xlsx" */ "xlsx");

  const workbook = XLSX.utils.book_new();
  workbook.Props = {
    Author: "AllTimely",
    LastAuthor: "AlLTimely",
    CreatedDate: new Date(),
  };

  return workbook;
};

export const createWorksheet = async (workbook, sheetName, rows = null) => {
  const XLSX = await import(/* webpackChunkName: "xlsx" */ "xlsx");

  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  return worksheet;
};

export const downloadWorkbook = async (workbook, filename) => {
  const XLSX = await import(/* webpackChunkName: "xlsx" */ "xlsx");
  XLSX.writeFile(workbook, filename);
};

export const readWorkbook = async (fileObj) => {
  const { read, utils } = await import(/* webpackChunkName: "xlsx" */ "xlsx");

  const arrayBuffer = await fileObj.arrayBuffer();
  const workbook = read(arrayBuffer, { type: "array" });

  // if first sheet name is an attendance chart (from Balco) then remove the first line (HACK)
  // it converts the sheet to json,removes the row, recreates the sheet, and assigns it to the workbook (ick)
  if (workbook.SheetNames[0].startsWith("Attendance Chart")) {
    const ws = workbook.Sheets[workbook.SheetNames[0]];

    // Convert sheet to array-of-arrays
    const data = utils.sheet_to_json(ws, { header: 1 });

    // Remove row (0-based index)
    // Example: remove Excel row 5 → index 4
    data.splice(0, 1);

    // Convert back to worksheet
    const newWs = utils.aoa_to_sheet(data);
    workbook.Sheets[workbook.SheetNames[0]] = newWs;
  }

  // ✅ Collect rows from all sheets
  const rows = workbook.SheetNames.flatMap((sheetName) =>
    utils.sheet_to_json(workbook.Sheets[sheetName], {
      defval: null,
    }),
  );

  // hack to import frmo cleveland
  for (const row of rows) {
    if (row["pcontact.email"]) {
      row["email"] = row["pcontact.email"];
    }
  }

  return rows;
};

export const readWorkbookRaw = async (fileObj) => {
  const { read, utils } = await import(/* webpackChunkName: "xlsx" */ "xlsx");

  const arrayBuffer = await fileObj.arrayBuffer();
  const workbook = read(arrayBuffer, { type: "array" });

  const sheetName = workbook.SheetNames[0];
  const sheet = workbook.Sheets[sheetName];

  // Convert to 2D array (rows x columns)
  const rows = utils.sheet_to_json(sheet, {
    header: 1, // <-- important
    defval: null, // keep empty cells
  });

  return rows;
};

export const readCSV = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const text = e.target.result;
        const rows = parseCsv(text);
        resolve(rows);
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
};

export const parseCsv = (csvText) => {
  const lines = csvText.trim().split(/\r?\n/);

  const headers = lines[0].split(",").map((h) => h.trim());

  return lines.slice(1).map((line) => {
    const values = line.split(",");
    return headers.reduce((obj, header, index) => {
      obj[header] = values[index]?.trim() ?? "";
      return obj;
    }, {});
  });
};
